module.exports = __webpack_public_path__ + "static/media/dice-1.1cd3d5b5.svg";